import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HvacIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hvac"}/>
}
